<div class="history-back-icon {{styleClass}}" *ngIf="historyBackShowIcon">
  <i class="icosun-arrowleft history-back-icon_icon" (click)="onClickIcon($event)"></i>
</div>
